import * as React from 'react';
import { SVGProps } from 'react';

const SvgResource = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M36.667 12.667H8.5v21.166h28.167V12.667Z"
    />
    <path fill={props.fill} d="M11.833 11.867V7.2h9.5L26 11.867H11.833Z" />
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M8.5 15H3.333l3.334 18.833h1.666"
    />
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="M22.5 18.5V28m4.833-4.667h-9.5"
    />
  </svg>
);

export default SvgResource;
